import { render, staticRenderFns } from "./radio-defaultValue-editor.vue?vue&type=template&id=ea052f8e&scoped=true&"
import script from "./radio-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./radio-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea052f8e",
  null
  
)

export default component.exports